import {createThunkRoutine} from 'redux-thunk-routine';
import {
  GET_ROLES,
  GET_APPLICATION_ROLES,
  CREATE_ROLE,
  DELETE_ROLE,
  UPDATE_ROLE,
  ASSIGN_ROLE,
  UN_ASSIGN_ROLE,
  GET_SUBJECTS,
} from '~modules/Auth/action-types';

export const GetRolesRoutine = createThunkRoutine(GET_ROLES);
export const GetApplicationRolesRoutine = createThunkRoutine(GET_APPLICATION_ROLES);

export const CreateRoleRoutine = createThunkRoutine(CREATE_ROLE);
export const DeleteRoleRoutine = createThunkRoutine(DELETE_ROLE);
export const UpdateRoleRoutine = createThunkRoutine(UPDATE_ROLE);

export const AssignRoleRoutine = createThunkRoutine(ASSIGN_ROLE);
export const UnAssignRoleRoutine = createThunkRoutine(UN_ASSIGN_ROLE);
